import './Recipient.sass';

import React, { FC, useCallback } from 'react';
import { RecipientProps } from '$core/Broadcast/Recipient/Recipient.interface';
import { useUserInfo } from '$hooks';
import { UnitName, UnitPhoto } from '$shared/components';
import { classNames as cn } from '$utils';
import { RadioItem } from '$uikit';

export const Recipient: FC<RecipientProps> = ({
  userId,
  onSelect,
  selected,
  disabled,
}) => {
  const user = useUserInfo(userId);
  const handleClick = useCallback(() => {
    onSelect(!selected);
  }, [selected]);

  return (
    <div
      onPointerUp={handleClick}
      className={cn('Recipient', {
        disabled,
      })}
    >
      <UnitPhoto unit={user} size="extra-small" routeName={null} />
      <div className="Recipient__name">
        <UnitName unit={user} />
      </div>
      <div className="Recipient__check">
        <RadioItem disabled={disabled} active={selected} />
      </div>
    </div>
  );
};
